/* Land on the Managed side of the pricing page when the link asks for it. v1.

   THE PROBLEM. The homepage's Managed face carries a "See Managed plans"
   button. It pointed at /pages/pricing, which always opens on Studio - so
   someone who had just read about Managed, and clicked a button that said
   Managed, arrived looking at Studio prices and had to find the switch for
   themselves. Every such visitor is one click from giving up on the page.

   THE FIX. The link is now /pages/pricing#managed and this reads the hash.
   The value matches the data-face the pricing page's own switch already uses
   ("studio" / "managed"), so the two cannot drift apart without it being
   obvious in both files at once. ?plan=managed is accepted too, because that
   is what anyone writing the link by hand is likely to reach for.

   WHY IT CLICKS THE BUTTON RATHER THAN SETTING THE STATE. The pricing page's
   flip owns its own state in a closure - which face is showing, the card
   class, the aria-selected on each tab, the stage height. There is no way in
   from outside and no reason to build a second copy of that logic that would
   then have to be kept in step. Clicking the control the page already has does
   exactly what a visitor clicking it does, and stays correct if that page is
   rewritten.

   WHY IT RETRIES. The pricing template is 128KB of hand-built markup and its
   switch is wired on DOMContentLoaded; this file is deferred, so the handler is
   normally there before this runs. Normally is not always - a slow stylesheet
   or a re-render can move it - so it tries a few times over about a second and
   then gives up rather than clicking into the void. It stops the moment the
   Managed tab reports itself selected, and it never clicks a tab that is
   already active, so nothing flips twice.

   NO SCROLLING. #managed matches no element on the page, so the browser has
   nothing to jump to and the visitor stays at the top where the switch is. If
   an element with that id is ever added, this needs re-thinking. */
(function () {
  var WANT = 'managed';

  function wanted() {
    var h = (location.hash || '').replace('#', '').toLowerCase();
    if (h === WANT) return true;
    return /[?&]plan=managed(&|$)/i.test(location.search || '');
  }

  if (!wanted()) return;

  var tries = 0;

  function go() {
    tries++;
    var btn = document.querySelector('.pf-switch button[data-face="' + WANT + '"]')
           || document.querySelector('[role="tab"][data-face="' + WANT + '"]');

    /* Already on Managed - either it was clicked, or the page opened there. */
    if (btn && btn.getAttribute('aria-selected') === 'true') return;

    if (btn) btn.click();

    /* Confirm it took. A click on a control whose handler has not been bound
       yet looks exactly like success from here, which is the whole reason for
       checking rather than assuming. */
    var done = btn && btn.getAttribute('aria-selected') === 'true';
    if (!done && tries < 6) setTimeout(go, 160);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go);
  else go();
})();
